export interface INotificationOptions {
    title?: string;
    message: string | Error;
    action?: INotificationAction;
    // TODO: Hook up duration and isSticky to be used properly
    duration?: number | null;
    isSticky?: boolean | null;
}

export interface INotificationAction {
    text: string;
    onClick: () => void;
}
